/**
 * The addresses of the CRM's record pages, written in one place: a company
 * (/company/:id), a group (/group/:id, formerly /company/group/:id, which
 * still leads there) and a contact (/contact/:id, formerly under its company
 * or group, which still lead there).
 */
export const companyPath = (companyId) => `/company/${companyId}`;
export const groupPath = (groupId) => `/group/${groupId}`;

// A contact's page, wherever it is opened from: its company or group comes
// from the contact itself (api contact/record).
export const contactPath = (contactId) => `/contact/${contactId}`;
